module.exports = __webpack_public_path__ + "img/img_happix_gift.66043b6.png";